export default {
      id: "introductionDiagram-usage",
      viewBox: "0 0 410 470",
      url: __webpack_public_path__ + "sprite.6656901b3ab9be5618a76678ad156ea6.svg#introductionDiagram-usage",
      toString: function () {
        return this.url;
      }
    }